import { render, staticRenderFns } from "./AlternativeDesigns.vue?vue&type=template&id=ac52b0f2&"
import script from "./AlternativeDesigns.vue?vue&type=script&lang=js&"
export * from "./AlternativeDesigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports